var mentions_default = {
  "mention": "_8lXj2",
  "mentionViewer": "ZMc2a",
  "cursorDefault": "XXGd0",
  "cursorPointer": "_7ijVQ"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
